module.exports = __webpack_public_path__ + "images/referenzen/animationsfilm/starpool_animation_erklaerfilm.jpg";